import StyledHeading from './StyledHeading';

export default StyledHeading;
